import apollo from 'graphql/apollo';
import { updateDiscountMutation } from 'graphql/mutations';

const updateDiscount = async ({ _id, name, value, type }) =>
  apollo.mutate({ mutation: updateDiscountMutation, variables: { _id, modifier: { name, value, type } } });
export default updateDiscount;
